export enum MedicationTimeOfDayEnum {
  MORNING = "morning",
  NOON = "noon",
  EVENING = "evening",
  NIGHT = "night",
}

export const MedicationTimeOfDayFriendlyNameMapping: Record<
  MedicationTimeOfDayEnum,
  string
> = {
  [MedicationTimeOfDayEnum.MORNING]: "Morning",
  [MedicationTimeOfDayEnum.NOON]: "Noon",
  [MedicationTimeOfDayEnum.EVENING]: "Evening",
  [MedicationTimeOfDayEnum.NIGHT]: "Night",
};

export const MedicationTimeOfDayDropdownOptions = [
  {
    value: MedicationTimeOfDayEnum.MORNING,
    label:
      MedicationTimeOfDayFriendlyNameMapping[MedicationTimeOfDayEnum.MORNING],
  },
  {
    value: MedicationTimeOfDayEnum.NOON,
    label: MedicationTimeOfDayFriendlyNameMapping[MedicationTimeOfDayEnum.NOON],
  },
  {
    value: MedicationTimeOfDayEnum.EVENING,
    label:
      MedicationTimeOfDayFriendlyNameMapping[MedicationTimeOfDayEnum.EVENING],
  },
  {
    value: MedicationTimeOfDayEnum.NIGHT,
    label:
      MedicationTimeOfDayFriendlyNameMapping[MedicationTimeOfDayEnum.NIGHT],
  },
];
